import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { useHistory, useLocation } from 'react-router-dom';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import CustomDialog from '../dialogs/CustomDialog';
import { getReminderTokenFromPath } from '../../../utils/common';

import environment from '../../../environment';
import AcceptReminderForEventMutation from '../../../mutations/AcceptReminderForEventMutation';

const  EventReminderAccepted = (props) => {

  const location = useLocation();

  const [dialogOpen, setDialogOpen] = useState(true);

  const { onTokenReceived } = props;

  const closeDialog = () => {
    setDialogOpen(false);
    onTokenReceived();
  };

  useEffect(() => {
    const token = getReminderTokenFromPath(location.search)
    AcceptReminderForEventMutation.commit(
      environment,
      token,
      (err, status) => {
        if (err || status === 'ok') {
          return;
        }
      }
    );
  }, [])

  return (
    <CustomDialog open={dialogOpen} onRequestClose={closeDialog}>
      <div className="notification-container">
        <DialogContent>
          <div className="notification-body">
            <div className="event-reminder-icon" />
            <h1>
              <FormattedMessageWrappedInSpan
                id="eventReminderAccepted.title"
                defaultMessage="Thank you!"
              />
            </h1>
            <FormattedMessageWrappedInSpan
              id="eventReminderAccepted.message"
              defaultMessage="Thank you for subscribing to our Reminder. As soon as the event goes online we will notify you."
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div className="notification-action">
            <button onClick={closeDialog}>
              <FormattedMessageWrappedInSpan
                id="eventReminderAccepted.closeButton"
                defaultMessage="Close"
              />
            </button>
          </div>
        </DialogActions>
      </div>
    </CustomDialog>
  );
}

EventReminderAccepted.propTypes = {
  onTokenReceived: PropTypes.func
};

export default EventReminderAccepted;